<template>
  <div class="app text-dark" style="font-family: 'Poppins';">
    <Navbar/>
      <div style="scroll-behavior: smooth; ">
      <main>
        <div class="p-0" ref="main_container" style="height: 105vh !important; width: 100%; overflow: hidden; position: fixed">
          <transition name="fade" mode="out-in">
            <router-view style="height: 105vh !important; overflow-y: auto"></router-view>
          </transition>

          <!-- <font-awesome-icon @click="loginModal = true" style="font-size: 37px; cursor: pointer; position: absolute; top: 40; right: 40; z-index: 1000" :icon="['fas', 'bars']"/> -->

          <div class="linear-warning w-100" style="z-index: -1; height: 150px; position: absolute; top: 0"></div>
          <div class="triangle-top linear-warning w-100"></div>
          <div class="linear-warning w-100" style="z-index: -1; height: 250px; position: absolute; bottom: -10px"></div>
          <div class="triangle-bottom linear-warning w-100"></div>
        </div>
      </main>
      
    </div>

        
    <b-modal id="loginModal" size="" centered v-model="loginModal" title="BootstrapVue" hide-footer hide-header>
      <div class="bg-white" style="border-radius: 10px; transition: all .5s;">
        <b-row class="m-0 linear-warning pt-3 pr-3 justify-content-end" style="border-top-left-radius: 10px; border-top-right-radius: 10px;">
          <font-awesome-icon @click="loginModal = false" style="font-size: 37px; cursor: pointer" :icon="['fas', 'times']"/>
        </b-row>
        <b-row class="m-0 linear-warning justify-content-center" >
        <h2 class="text-center text-dark" >mein eatDorado</h2>
        </b-row>
        <b-row class="m-0 pt-3 linear-warning triangle-modal justify-content-between">
          
        </b-row>
        <b-row class="m-0 justify-content-around" style="position: relative; top: -4vh">
          <b-form @submit.prevent="onSubmit" style="width: 90%">
            <b-form-group
              v-if="registerActive"
              id="input-group-1"
              label="Name:"
              label-for="input-1"
             
            >
              <b-form-input
                :state="!form.name ? false : true"
                id="input-1"
                v-model="form.name"
                type="text"
                placeholder="Name eingeben"
                required
              ></b-form-input>
            </b-form-group>
            <b-form-group
              id="input-group-2"
              label="E-Mail-Addresse:"
              label-for="input-2"
            >
              <b-form-input
                :state="!form.email ? false : true"
                id="input-2"
                v-model="form.email"
                type="email"
                placeholder="E-Mail eingeben"
                required
              ></b-form-input>
            </b-form-group>
          <b-form-group id="input-group-3" label="Passwort" label-for="input-3">
            <b-form-input
              :state="!form.password ? false : true"
              id="input-3"
              v-model="form.password"
              placeholder="Passwort eingeben..."
              type="password"
              required
            ></b-form-input>
          </b-form-group>
          <b-form-group v-if="registerActive" id="input-group-4" label="Passwort wiederholen" label-for="input-4">
            <b-form-input
              :state="!form.passwordRepeat ? false : true"
              id="input-4"
              v-model="form.passwordRepeat"
              placeholder="Passwort wiederholen..."
              type="password"
              required
            ></b-form-input>
          </b-form-group>
          <b-form-group v-if="registerActive" id="input-group-5">
            <b-form-checkbox-group
              :state="!form.checked > 0 ? false : true"
              v-model="form.checked"
              id="checkboxes-4"
              required
            >
              <b-form-checkbox value="me"><a href="/datenschutz" target="_blank">Datenschutz</a> gelesen und akzeptiert</b-form-checkbox>
            </b-form-checkbox-group>
          </b-form-group>
          <b-button type="submit" style="width: 100%" size="md" variant="dark">{{ registerActive ? 'registrieren' : 'anmelden' }}</b-button>
          <b-button style="width: 100%" size="md" class="mt-3" variant="outline-dark" @click="registerActive = !registerActive">{{ registerActive ? 'einloggen' : 'Account erstellen' }} </b-button>
          </b-form>
          
        </b-row>
        
      </div>
    </b-modal>
    
  </div>
</template>

<script>
import coreData from '@/mixins/coreDataMixin'
import Navbar from '@/components/Navbar'

export default {
  name: 'MainContainer',
  mixins: [coreData],
  components: {
    Navbar,
  },
  data() {
    return {
      showDetail: false,
      form: {},
      loginModal: false,
      registerActive: false,
      orderBuffer: []
    }
  },
  props: {

  },
  watch:{
    orders(){
      if(this.orderBuffer.length > 0){
        this.orders.forEach(element => {
          if(!this.orderBuffer.find(order => order._id == element._id) && element.customer_verified){
            this.makeToast()
          }
        })
        this.orderBuffer = []
        this.orders.forEach(element => {
          if(element.customer_verified){
            this.orderBuffer.push({_id: element._id})
          }
        });
      }else{
        this.orders.forEach(element => {
          if(element.customer_verified){
            this.orderBuffer.push({_id: element._id})
          }
        });
      }
    }
  },
  mounted(){
    try {
      setInterval( this.refreshPeriodic, 30000);
    } catch (error) {
      console.log(error)
    }
  },
  computed: {
    darkMode(){
      return this.$store.getters.darkMode
    }
  },
  methods: {
    makeToast(append = false) {
        this.toastCount++
        this.$bvToast.toast(`Eine neue Bestellung ist eingetroffen!`, {
          title: 'Neue Bestellung!',
          autoHideDelay: 10000,
          appendToast: append
        })
        this.playSound()
      },
    refreshPeriodic(){
      this.$store.dispatch('getOrders')
      this.$store.dispatch('getTables')
      this.$store.dispatch('getInHouseOrders')
    }
  }
}
</script>

<style lang="scss" scoped>

.triangle-top {
    z-index: -1;
    position: absolute;
    top: 150px;
    height: 10vh;
    clip-path: polygon(0 0,0 100%,100% 0,100% 0);
    -webkit-clip-path: polygon(0 0,100% 0,100% 0,0 100%);
  }

  .triangle-bottom {
    z-index: -1;
    position: absolute;
    bottom: 239px;
    height: 10vh;
    width: 100%;
    clip-path: polygon(100% 0, 0 100%, 100% 100%);
    -webkit-clip-path: polygon(100% 0, 0 100%, 100% 100%);
  }

.app {
  background-color: white;
  min-height: 100vh;
  margin-top: -10px;
}

</style>

<style lang="scss" >

.collapsed > .when-open,
.not-collapsed > .when-closed {
  display: none;
}

p:focus{
  display: none;
}

.modal-backdrop {
  width: 100% !important;
  height: 100% !important
}

.scale {
  transform: scale(0.9) !important;
  transform-origin: 0px 0px 0px 0px 0px !important;
  width: 2000px;
  max-width: 110vw;
}

@media print
{
    .no-print, .no-print *
    {
        display: none !important;
    }
}

@keyframes rotating
    {
    from
        {
        transform: rotate(0deg);
        -o-transform: rotate(0deg);
        -ms-transform: rotate(0deg);
        -moz-transform: rotate(0deg);
        -webkit-transform: rotate(0deg);
        }
    to
        {
        transform: rotate(360deg);
        -o-transform: rotate(360deg);
        -ms-transform: rotate(360deg);
        -moz-transform: rotate(360deg);
        -webkit-transform: rotate(360deg);
        }
    }
@-webkit-keyframes rotating
    {
    from
        {
        transform: rotate(0deg);
        -webkit-transform: rotate(0deg);
        }
    to
        {
        transform: rotate(360deg);
        -webkit-transform: rotate(360deg);
        }
    }
.rotating
    {
    -webkit-animation: rotating 1s linear infinite;
    -moz-animation: rotating 1s linear infinite;
    -ms-animation: rotating 1s linear infinite;
    -o-animation: rotating 1s linear infinite;
    animation: rotating 1s linear infinite;
    }
  .disabled {
    opacity: .5;
  }

.hover {

  cursor: pointer;
}
.showcase-lite {
    border-radius: 8px;
    border-left-width: 4px;
    border-left-style: solid;
  //  box-shadow: -1px -1px 1px rgba(255,255,255,0.05), 1px 1px 2px rgba(0,0,0, .5) !important
  }

  .dropshadow {
    //border-radius: 10px;
    //border: none !important;
    //box-shadow: -3px -3px 7px #ffffff73, 3px 3px 5px rgba(94,104,121, .288) !important
    box-shadow: 1px 1px 1px rgba(255,255,255,0.05), 1px 1px 5px rgba(0,0,0, .5) !important
  }

  td {
    padding: 0 !important
  }

  .showcase-light{
    cursor: pointer;
    padding: 5px;
    border: none;
    border-radius: 5px;
    margin-bottom: 5px;
  }
  .main-header{
    box-shadow: 3px -5px 15px rgba(255, 255, 255, 0.05), 3px 2px 15px rgba(0,0,0, .5) !important;
    padding-top: auto;
    text-align: center;
    position: relative;;
    height: 300px;
    width: 100%;
    // background: url('../assets/appdev.jpg');
    background-repeat: no-repeat;
    background-size: cover;
    background-position: left;
    border-bottom-left-radius: 100px;
    border-bottom-right-radius: 100px;
  }

  .overlay {
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: black;
    opacity: .5;
    border-bottom-left-radius: 100px;
    border-bottom-right-radius: 100px;
  }

.pulse {
  cursor: pointer;
  animation: pulse 2s infinite;
}
.pulse:hover {
  animation: none;
}

@-webkit-keyframes pulse {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(29, 207, 38, 2);
  }
  70% {
      -webkit-box-shadow: 0 0 0 10px rgb(207, 29, 29);
  }
  100% {
      -webkit-box-shadow: 0 0 0 0 rgba(29, 207, 38, 0);
  }
}
@keyframes pulse {
  0% {
    -moz-box-shadow: 0 0 0 0 rgba(29, 207, 38, 2);
    box-shadow: 0 0 0 0 rgb(207, 29, 29);
  }
  70% {
      -moz-box-shadow: 0 0 0 10px rgb(207, 29, 29);
      box-shadow: 0 0 0 10px rgba(29, 207, 38, 0);
  }
  100% {
      -moz-box-shadow: 0 0 0 0 rgba(29, 207, 38, 0);
      box-shadow: 0 0 0 0 rgba(29, 207, 38, 0);
  }
}
  .bg-dark {
    transition: .3s
  }
  .bg-white {
    transition: .3s
  }
  .main-header-container{
    box-shadow: inset -5px -5px 5px rgba(255,255,255,0.05), inset 2px 2px 5px rgba(0,0,0, .5) !important;
    padding-top: auto;
    text-align: center;
    position:relative;
    height: 335px;
    width: 100%;
    border-bottom-left-radius: 100px;
    border-bottom-right-radius: 100px;
  }

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.slide-leave-active,
.slide-enter-active {
  transition: .5s;
}
.slide-enter {
  transform: translate(100%, 0);
}
.slide-leave-to {
  transform: translate(-100%, 0);
}

.rotate-leave-active,
.rotate-enter-active {
  transition: .5s;
}
.rotate-enter {
  transform: rotate(-180deg);
}
.rotate-leave-to {
  transform: rotate(180deg);
}

.slideIn-leave-active,
.slideIn-enter-active {
  transition: .3s;
}
.slideIn-enter {
  transform: translate(100%, 0);
}
.slideIn-leave-to {
  transform: translate(100%, 0);
}

.slideLe-leave-active,
.slideLe-enter-active {
  transition: .3s;
}
.slideLe-enter {
  transform: translate(-100%, 0);
}
.slideLe-leave-to {
  transform: translate(-100%, 0);
}

.slideRi-leave-active,
.slideRi-enter-active {
  transition: .3s;
}
.slideRi-enter {
  transform: translate(100%, 0);
}
.slideRi-leave-to {
  transform: translate(100%, 0);
}

.sliderev-leave-active,
.sliderev-enter-active {
  transition: .5s;
}
.sliderev-enter {
  transform: translate(-100%, 0);
}
.sliderev-leave-to {
  transform: translate(100%, 0);
}

  .neumorphism {
    //border-radius: 10px;
    border: none !important;
    //box-shadow: -3px -3px 7px #ffffff73, 3px 3px 5px rgba(94,104,121, .288) !important
    box-shadow: -2px -2px 5px rgba(255,255,255,0.05), 2px 2px 5px rgba(0,0,0, .5) !important
  }
  
  .neumorphism-1 {
    //border-radius: 10px;
    border: none !important;
    //box-shadow: -3px -3px 7px #ffffff73, 3px 3px 5px rgba(94,104,121, .288) !important
    box-shadow: inset -5px -5px 5px rgba(255,255,255,0.05), inset 2px 2px 5px rgba(0,0,0, .5) !important
  }

  .inner {
    overflow: auto;
    margin-top: -2px;
    margin-left: -2px;
    position: absolute;
    background: #17e6df;
    padding: 1em;
    border-radius: 10px;
    width: 225px;
    height: 255px;
    clip-path: circle(7% at 85% 12%);
    transition: all .5s ease-in-out;
    cursor: pointer;

    &:hover {
        clip-path: circle(75%);
        background: #666666;
    }

    h4 {
        color: #17e6df !important;
        margin: 0;
    }

    p {
        color: white;
        font-size: .8rem;
        
    }

    

    span {
        float: right;
        color: white;
        font-weight: bold;
        transition: color .5s;
        position: relative;
        margin-right: 8%;
        margin-top: 2%;
    }
    &:hover span {
        color: rgba(255,255,255,0)
    }
    &:hover h4 {
        color: white !important
    }
}

  .custom-nav {
    cursor: pointer;
    .focus {
      outline: 0;
    }
  }

  .custom-nav:hover{
    color: #17e6df !important;
  }

  .modal-body {
    background-color: rgba(0,0,0,.0001) !important;
    border: none;
  }
  .modal-content {
    background-color: rgba(0,0,0,.0001) !important;
    border: none;
  }

  .showcase {
    padding: 20px;
    border-radius: 10px;
    //box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
    box-shadow: inset -5px -5px 5px rgba(255,255,255,0.05), inset 2px 2px 5px rgba(0,0,0, .5) !important
  }

  .showcase-invert {
    transition: all .5s;
    padding: 15px;
    border-radius: 5px;
    border: none;
    -webkit-box-shadow: 0 1px 4px 0 rgba(0,0,0,.14);
    box-shadow: 0 1px 4px 0 rgba(0,0,0,.14);
  }

  .brand-header {
    box-shadow: 5px 5px 5px rgba(255,255,255,0.05), 2px 2px 5px rgba(0,0,0, .5) !important;
    padding: 10px;
    border-radius: 5px;
    background: linear-gradient(60deg,#26c6da,#00acc1);
    &:hover {
        transform: translate(0, -10px);
    }
  }

  .showcase-header {
    transition: all .2s;
    margin: -30px 0px 10px;
    box-shadow: 0 12px 20px -10px rgba(104, 101, 101, 0.28), 0 4px 20px 0 rgba(0,0,0,.12), 0 7px 8px -5px rgba(104, 101, 101,.2);
    -webkit-box-shadow: 0 12px 20px -10px rgba(104, 101, 101,.28), 0 4px 20px 0 rgba(0,0,0,.12), 0 7px 8px -5px rgba(104, 101, 101,.2);
    padding: 10px;
    border-radius: 5px;
    animation-duration: 1s;
    &:hover {
        //transform: translate(0, -60px);
    }
  }

  

  .linear-danger {
    background: linear-gradient(60deg,#ef5350,#e53935);
  }

  .linear-info {
    background: linear-gradient(60deg,#26c6da,#00acc1);
  }

  .linear-success {
    background: linear-gradient(60deg,#66bb6a,#43a047);
  }

  .linear-dark {
    background: linear-gradient(60deg,#343a40,rgb(61, 59, 59));
  }

  .linear-warning {
    background: rgb(255,193,7);
    background: linear-gradient(90deg, rgba(255,193,7,1) 0%, rgba(253,255,51,1) 100%);
  }

  .linear-primary {
    background: linear-gradient(60deg,#00acc1,#1755da);
  }



  .hover-expand{
    transform: scale(1.0);
    transition: all .3s ease-in-out;
  }

  .hover-expand:hover {
    transform: scale(1.05);
    transition: all .3s ease-in-out;
    z-index: 1000 !important;
  }

  .center {
    margin: 0;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .btn-custom {
    border-radius: 10px !important;
    border: none !important;
    //box-shadow: -3px -3px 7px #ffffff73, 3px 3px 5px rgba(94,104,121, .288) !important
    box-shadow: -2px -2px 5px rgba(255,255,255,0.05), 2px 2px 5px rgba(0,0,0, .5) !important
  }

  .neumorphism {
    //border-radius: 10px;
    border: none !important;
    //box-shadow: -3px -3px 7px #ffffff73, 3px 3px 5px rgba(94,104,121, .288) !important
    box-shadow: -2px -2px 5px rgba(255,255,255,0.05), 2px 2px 5px rgba(0,0,0, .5) !important
  }
</style>